import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import Pagination from "../../utils/Pagination";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ContentLoader from "../../utils/ContentLoader";
import { Popover } from "antd";
import { getLangValue } from "../../utils/tools";
import { PRAYER_REQUEST_TYPE_LABELS } from "../../utils/prayerRequestUtils";

const PrayerRequestTable = ({
    prayerRequests,
    page,
    setPage,
    totalPages,
    totalEntries,
    sort,
    order,
    setOrder,
    setSort,
    search,
    setSearch,
    entriesPerPage,
    setEntriesPerPage,
    onDelete,
}) => {
    const [loading] = useState(false);

    const navigate = useNavigate();

    const headerConfig = [
        { key: "notes", label: "Notes", sortable: false, className: "w-45", },
        { key: "prayer-request-type", label: "Prayer Request Type", sortable: false, className: "w-25", },
        { key: "likes", label: "Likes", sortable: false, className: "w-10", },
        { key: "status", label: "Status", sortable: false, className: "w-10", },
        { key: "action", label: "Action", sortable: false, className: "w-10", },
    ];

    if (loading) return <ContentLoader />;

    // console.log("prayerRequests==>>", prayerRequests)

    return (
        <div className="card basic-data-table text-sm overflow-x-auto">
            <style>
                {`
            .w-45 {
                width: 45% !important;
                min-width: 250px;
            }

            .w-25 {
                width: 25% !important;
                min-width: 120px;
            }
            .w-10 {
                width: 10% !important;
                min-width: 100px;
            }
        `}
            </style>
            <div className="card-header d-flex justify-content-end align-items-center">
                <div className="d-flex align-items-center gap-3">
                    <SearchBy
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(1);
                        }}
                    />

                    <button
                        className="btn btn-primary-600"
                        type="button"
                        onClick={() =>
                            navigate("/prayer-request-form")
                        }
                    >
                        <Icon icon="fa6-regular:square-plus" />
                        Add
                    </button>
                </div>
            </div>

            <div className="card-body">
                <div className="w-full overflow-x-auto">
                    <table className="table bordered-table mb-0 text-sm w-full min-w-max">
                        <thead>
                            <tr>
                                {TableSortHeaders(
                                    headerConfig,
                                    sort,
                                    order,
                                    setSort,
                                    setOrder,
                                    setPage
                                )}
                            </tr>
                        </thead>

                        <tbody>
                            {Array.isArray(prayerRequests) &&
                                prayerRequests.length > 0 ? (
                                prayerRequests.map((item) => (
                                    <tr key={item.id}>
                                        <td className="w-60">
                                            {getLangValue(item.notes)}
                                        </td>

                                        <td className="w-60">
                                            {PRAYER_REQUEST_TYPE_LABELS[item?.prayer_request_type?.name] || "-"}
                                        </td>

                                        <td className="w-15">
                                            {item.likes}
                                        </td>

                                        <td className="w-15">
                                            <span
                                                className={`px-24 py-4 rounded-pill fw-medium text-sm ${item.status === "pending"
                                                    ? "bg-warning-focus text-warning-600"
                                                    : item.status === "accepted"
                                                        ? "bg-success-focus text-success-main"
                                                        : "bg-danger-focus text-danger-main"
                                                    }`}
                                            >
                                                {item.status?.charAt(0).toUpperCase() +
                                                    item.status?.slice(1)}
                                            </span>
                                        </td>


                                        <td className="w-10">
                                            <div className="d-flex align-items-center gap-8">
                                                <Popover
                                                    trigger="click"
                                                    placement="bottomRight"
                                                    overlayClassName="action-popover"
                                                    content={
                                                        <div className="action-list">
                                                            <button
                                                                onClick={() =>
                                                                    navigate(
                                                                        `/prayer-request-form/${item.id}`
                                                                    )
                                                                }
                                                                className="action-item text-success-main"
                                                            >
                                                                <Icon icon="lucide:edit" />
                                                                <span>
                                                                    Edit
                                                                </span>
                                                            </button>

                                                            <button
                                                                className="action-item text-danger-main"
                                                                onClick={() =>
                                                                    onDelete(
                                                                        item.id
                                                                    )
                                                                }
                                                            >
                                                                <Icon icon="mingcute:delete-2-line" />
                                                                <span>
                                                                    Delete
                                                                </span>
                                                            </button>
                                                        </div>
                                                    }
                                                >
                                                    <button
                                                        type="button"
                                                        className="w-32-px h-32-px bg-neutral-300 rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                                                    >
                                                        <Icon icon="mdi:dots-vertical" />
                                                    </button>
                                                </Popover>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={4}
                                        className="text-center"
                                    >
                                        No Prayer Requests Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                />
            </div>
        </div>
    );
};

export default PrayerRequestTable;